import type { AppProps } from "next/app";
import { ChakraProvider } from "@chakra-ui/react";
import { AuthProvider } from "../context/AuthContext";
import theme from "../utils/theme";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TrialRouteGuard } from "../components/guards/TrialRouteGuard";
import TrialStatusHandler from "../components/handlers/TrialStatusHandler";
import { PwaHead } from "@/components/pwa/PwaHead";
import { PwaProvider } from "@/components/pwa/PwaProvider";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ChakraProvider theme={theme}>
      <PwaHead />
      <AuthProvider>
        <PwaProvider>
          <TrialRouteGuard />
          <TrialStatusHandler />
          <Component {...pageProps} />
          <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          />
        </PwaProvider>
      </AuthProvider>
    </ChakraProvider>
  );
}

export default MyApp;
